import React from 'react';
import { Paper, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import CategoryTableRow from './CategoryTableRow';

const CategoryTable = ({ filteredCategoryData, currency, handleExpandCategory, expandedCategory }) => (
  <Paper sx={{ overflow: 'auto' }}>
    <Table sx={{ minWidth: 650 }} aria-label="table by month">
      <TableHead>
        <TableRow>
          <TableCell align="center" sx={{ position: 'sticky', left: 0, bgcolor: 'background.paper', zIndex: 1 }}>Categoria</TableCell>
          <TableCell align="center">Ano</TableCell>
          <TableCell align="center">Jan</TableCell>
          <TableCell align="center">Fev</TableCell>
          <TableCell align="center">Mar</TableCell>
          <TableCell align="center">Abr</TableCell>
          <TableCell align="center">Mai</TableCell>
          <TableCell align="center">Jun</TableCell>
          <TableCell align="center">Jul</TableCell>
          <TableCell align="center">Ago</TableCell>
          <TableCell align="center">Set</TableCell>
          <TableCell align="center">Out</TableCell>
          <TableCell align="center">Nov</TableCell>
          <TableCell align="center">Dez</TableCell>
          <TableCell align="center"><b>Total</b></TableCell>
          <TableCell align="center">Ações</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredCategoryData.map((row, index) => (
          <CategoryTableRow
            key={row.rowKey || row.category}
            row={row}
            index={index}
            currency={currency}
            handleExpandCategory={handleExpandCategory}
            expandedCategory={expandedCategory}
          />
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default CategoryTable;
